import {
  Companion_getInstance1ljiqntaxe0m9 as Companion_getInstance,
  Companion_getInstance2r6pafkc2qafn as Companion_getInstance_0,
  Companion_instancef6fjaxfv49x1 as Companion_instance,
  Companion_instancen4rpxo41w4o4 as Companion_instance_0,
} from '../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/models.mjs';
import { ModelCache1j2q0r8bmhrox as ModelCache } from '../../../../../lightning-server-kiteui-client/com/lightningkite/lightningserver/db/ModelCache.mjs';
import { Companion_instance1tjb9nvha71oi as Companion_instance_1 } from '../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/dynamicSettings.mjs';
import { Companion_getInstance2v1f7yxfwu10q as Companion_getInstance_1 } from '../../../../../lightning-server-sessions-shared/com/lightningkite/lightningserver/sessions/sessionModels.mjs';
import {
  Companion_getInstance2xu56kdtu70pg as Companion_getInstance_2,
  Companion_instanced3br7ruy9wqq as Companion_instance_2,
} from '../../../../../lightning-server-sessions-shared/com/lightningkite/lightningserver/sessions/AuthSecrets.mjs';
import { Companion_getInstanceddq4orui8c5e as Companion_getInstance_3 } from '../../../../../lightning-server-notifications-shared/com/lightningkite/lightningserver/notifications/notificationModels.mjs';
import { Companion_instance9ofeumbwb97p as Companion_instance_3 } from '../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/notifications.mjs';
import { Companion_getInstance1y5mh6uowmcdd as Companion_getInstance_4 } from '../../../../../lightning-server-notifications-shared/com/lightningkite/lightningserver/notifications/subscriptions/subscriptionModels.mjs';
import {
  Companion_getInstance2jaanzr07h9qp as Companion_getInstance_5,
  Companion_instanceh1a9dxwm5f9z as Companion_instance_4,
  Companion_getInstance8cw09c4jvk3w as Companion_getInstance_6,
  Companion_getInstance3n8qsn7k1orly as Companion_getInstance_7,
  Companion_getInstance29yv2m82qhueb as Companion_getInstance_8,
  Companion_getInstance5c3fz7snx10k as Companion_getInstance_9,
  Companion_instance31zndpf9pf1oi as Companion_instance_5,
  Companion_instance3i4ej7wheox62 as Companion_instance_6,
  Companion_getInstance3624xnlg0493t as Companion_getInstance_10,
  Companion_instance2mni8afnohjti as Companion_instance_7,
  Companion_instanceu8ez89pi8m0d as Companion_instance_8,
} from '../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/domain.mjs';
import {
  Companion_getInstancevgnjncsigc6q as Companion_getInstance_11,
  Companion_getInstance2yczpxlc95n6h as Companion_getInstance_12,
} from '../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/applications.mjs';
import {
  Companion_getInstance3rx4dbijulyuv as Companion_getInstance_13,
  Companion_instancesqd80ja9ulcs as Companion_instance_9,
  Companion_getInstanceyrbofvk90ue2 as Companion_getInstance_14,
  Companion_instance2km53rz6tjv2o as Companion_instance_10,
} from '../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/careRates.mjs';
import {
  Companion_getInstance3a5neho85mvmw as Companion_getInstance_15,
  Companion_getInstance1z0h5xsn2wljo as Companion_getInstance_16,
} from '../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/subsidyRates.mjs';
import {
  Companion_instance1d8b451omsiul as Companion_instance_11,
  Companion_instance3rsay32qgy1xl as Companion_instance_12,
  Companion_getInstance1ytzay7iyj05v as Companion_getInstance_17,
  Companion_getInstance2ufvbwwa42es2 as Companion_getInstance_18,
} from '../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/money.mjs';
import { Companion_getInstance1ymz2mf6vmsl4 as Companion_getInstance_19 } from '../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/employerAggregations.mjs';
import {
  Companion_getInstance67t3dbcjzlfh as Companion_getInstance_20,
  Companion_getInstance29sht6afyr9n6 as Companion_getInstance_21,
  Companion_getInstancecv02zznkeg7m as Companion_getInstance_22,
} from '../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/survey.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var CachedApiClass;
function CachedApi() {
  if (CachedApiClass === VOID) {
    class $ {
      constructor(uncached) {
        this.uncached_1 = uncached;
        this.appReleases_1 = new (ModelCache())(this.uncached_1.get_appRelease_glbnzj_k$(), Companion_getInstance().serializer_9w0wvi_k$());
        this.dynamicSettings_1 = new (ModelCache())(this.uncached_1.get_dynamicSettings_6ukhax_k$(), Companion_instance_1.serializer_9w0wvi_k$());
        this.users_1 = new (ModelCache())(this.uncached_1.get_user_wovspg_k$(), Companion_getInstance_0().serializer_9w0wvi_k$());
        this.sessions_1 = new (ModelCache())(this.uncached_1.get_userAuth_yt6u3g_k$(), Companion_getInstance_1().serializer_5gdsw7_k$(Companion_getInstance_0().serializer_9w0wvi_k$(), Companion_instance.serializer_9w0wvi_k$()));
        this.totpSecrets_1 = new (ModelCache())(this.uncached_1.get_userAuth_yt6u3g_k$().get_totp_wov340_k$(), Companion_getInstance_2().serializer_9w0wvi_k$());
        this.passwordSecrets_1 = new (ModelCache())(this.uncached_1.get_userAuth_yt6u3g_k$().get_password_bodifw_k$(), Companion_instance_2.serializer_9w0wvi_k$());
        this.fcmTokens_1 = new (ModelCache())(this.uncached_1.get_fcmToken_a95zde_k$(), Companion_instance_0.serializer_9w0wvi_k$());
        this.notifications_1 = new (ModelCache())(this.uncached_1.get_tCGNotifications_dv414p_k$(), Companion_getInstance_3().serializer_o2vhsn_k$(Companion_instance.serializer_9w0wvi_k$(), Companion_instance_3.serializer_9w0wvi_k$()));
        this.notificationSendMethods_1 = new (ModelCache())(this.uncached_1.get_tCGNotifications_dv414p_k$().get_subscriptions_vnh9l9_k$(), Companion_getInstance_4().serializer_rzxuna_k$(Companion_instance.serializer_9w0wvi_k$()));
        this.families_1 = new (ModelCache())(this.uncached_1.get_family_d7lffx_k$(), Companion_getInstance_5().serializer_9w0wvi_k$());
        this.familyEmployerAuthorizations_1 = new (ModelCache())(this.uncached_1.get_familyEmployerAuthorization_hehyj5_k$(), Companion_instance_4.serializer_9w0wvi_k$());
        this.familyApplications_1 = new (ModelCache())(this.uncached_1.get_familyApplication_7vdin7_k$(), Companion_getInstance_11().serializer_9w0wvi_k$());
        this.providerApplications_1 = new (ModelCache())(this.uncached_1.get_providerApplication_tefbxy_k$(), Companion_getInstance_12().serializer_9w0wvi_k$());
        this.children_1 = new (ModelCache())(this.uncached_1.get_child_ipppmb_k$(), Companion_getInstance_6().serializer_9w0wvi_k$());
        this.childrenPlacement_1 = new (ModelCache())(this.uncached_1.get_childPlacement_o77pq_k$(), Companion_getInstance_7().serializer_9w0wvi_k$());
        this.childrenAttendance_1 = new (ModelCache())(this.uncached_1.get_childAttendance_eqcv24_k$(), Companion_getInstance_8().serializer_9w0wvi_k$());
        this.careLocationClosures_1 = new (ModelCache())(this.uncached_1.get_careLocationClosure_wog2z0_k$(), Companion_getInstance_9().serializer_9w0wvi_k$());
        this.locationAttendancePeriods_1 = new (ModelCache())(this.uncached_1.get_locationAttendancePeriod_ojr4ns_k$(), Companion_instance_5.serializer_9w0wvi_k$());
        this.careProviders_1 = new (ModelCache())(this.uncached_1.get_careProvider_y0cmmt_k$(), Companion_instance_6.serializer_9w0wvi_k$());
        this.careLocations_1 = new (ModelCache())(this.uncached_1.get_careLocation_drerzj_k$(), Companion_getInstance_10().serializer_9w0wvi_k$());
        this.employers_1 = new (ModelCache())(this.uncached_1.get_employer_c2djlo_k$(), Companion_instance_7.serializer_9w0wvi_k$());
        this.grants_1 = new (ModelCache())(this.uncached_1.get_grant_is33zn_k$(), Companion_instance_8.serializer_9w0wvi_k$());
        this.careLocationPrograms_1 = new (ModelCache())(this.uncached_1.get_careLocationPrograms_g0oima_k$(), Companion_getInstance_13().serializer_9w0wvi_k$());
        this.careLocationProgramDateds_1 = new (ModelCache())(this.uncached_1.get_careLocationProgramDated_cjifxd_k$(), Companion_instance_9.serializer_9w0wvi_k$());
        this.careProgramTemplates_1 = new (ModelCache())(this.uncached_1.get_careProgramTemplate_sacmzo_k$(), Companion_getInstance_14().serializer_9w0wvi_k$());
        this.careProgramTemplateDateds_1 = new (ModelCache())(this.uncached_1.get_careProgramTemplateDated_lad5ki_k$(), Companion_instance_10.serializer_9w0wvi_k$());
        this.employerRates_1 = new (ModelCache())(this.uncached_1.get_employerRates_stalch_k$(), Companion_getInstance_15().serializer_9w0wvi_k$());
        this.grantRates_1 = new (ModelCache())(this.uncached_1.get_grantRates_6bprq8_k$(), Companion_getInstance_16().serializer_9w0wvi_k$());
        this.grantAccountTransactions_1 = new (ModelCache())(this.uncached_1.get_grantAccountTransaction_b8gjzw_k$(), Companion_instance_11.serializer_9w0wvi_k$());
        this.employerAccountTransactions_1 = new (ModelCache())(this.uncached_1.get_employerAccountTransaction_bpegb9_k$(), Companion_instance_12.serializer_9w0wvi_k$());
        this.employerMonthAggregates_1 = new (ModelCache())(this.uncached_1.get_employerMonthAggregates_z5j4ls_k$(), Companion_getInstance_19().serializer_9w0wvi_k$());
        this.careProviderRemittances_1 = new (ModelCache())(this.uncached_1.get_careProviderRemittance_7bo3o7_k$(), Companion_getInstance_17().serializer_9w0wvi_k$());
        this.careProviderRemittanceSinglechildrenDay_1 = new (ModelCache())(this.uncached_1.get_singleChildDay_52scz3_k$(), Companion_getInstance_18().serializer_9w0wvi_k$());
        this.surveys_1 = new (ModelCache())(this.uncached_1.get_survey_jo9uub_k$(), Companion_getInstance_20().serializer_9w0wvi_k$());
        this.questionResponses_1 = new (ModelCache())(this.uncached_1.get_questionResponse_p55ixc_k$(), Companion_getInstance_21().serializer_9w0wvi_k$());
        this.surveyProgresses_1 = new (ModelCache())(this.uncached_1.get_surveyProgress_gv29io_k$(), Companion_getInstance_22().serializer_9w0wvi_k$());
      }
      get_users_izsycf_k$() {
        return this.users_1;
      }
      get_notifications_jts33z_k$() {
        return this.notifications_1;
      }
      get_notificationSendMethods_n4dl6_k$() {
        return this.notificationSendMethods_1;
      }
      get_families_is4v1x_k$() {
        return this.families_1;
      }
      get_familyEmployerAuthorizations_srfp8e_k$() {
        return this.familyEmployerAuthorizations_1;
      }
      get_familyApplications_uxaw4w_k$() {
        return this.familyApplications_1;
      }
      get_providerApplications_bz9fcz_k$() {
        return this.providerApplications_1;
      }
      get_children_4cwbp4_k$() {
        return this.children_1;
      }
      get_childrenPlacement_hazabn_k$() {
        return this.childrenPlacement_1;
      }
      get_childrenAttendance_3o0zzj_k$() {
        return this.childrenAttendance_1;
      }
      get_careLocationClosures_im9skn_k$() {
        return this.careLocationClosures_1;
      }
      get_locationAttendancePeriods_kbvlcb_k$() {
        return this.locationAttendancePeriods_1;
      }
      get_careProviders_b5tc2w_k$() {
        return this.careProviders_1;
      }
      get_careLocations_f1rtw_k$() {
        return this.careLocations_1;
      }
      get_employers_iw3lox_k$() {
        return this.employers_1;
      }
      get_grants_dxrzz4_k$() {
        return this.grants_1;
      }
      get_careLocationPrograms_g0oima_k$() {
        return this.careLocationPrograms_1;
      }
      get_careLocationProgramDateds_xnbfxu_k$() {
        return this.careLocationProgramDateds_1;
      }
      get_careProgramTemplates_ojj53j_k$() {
        return this.careProgramTemplates_1;
      }
      get_careProgramTemplateDateds_knbayp_k$() {
        return this.careProgramTemplateDateds_1;
      }
      get_employerRates_stalch_k$() {
        return this.employerRates_1;
      }
      get_grantRates_6bprq8_k$() {
        return this.grantRates_1;
      }
      get_grantAccountTransactions_6vb227_k$() {
        return this.grantAccountTransactions_1;
      }
      get_employerAccountTransactions_7pvrwe_k$() {
        return this.employerAccountTransactions_1;
      }
      get_employerMonthAggregates_z5j4ls_k$() {
        return this.employerMonthAggregates_1;
      }
      get_careProviderRemittances_dyezti_k$() {
        return this.careProviderRemittances_1;
      }
      get_surveys_tdixlc_k$() {
        return this.surveys_1;
      }
      get_questionResponses_1whaxp_k$() {
        return this.questionResponses_1;
      }
      get_surveyProgresses_a5rnfi_k$() {
        return this.surveyProgresses_1;
      }
    }
    initMetadataForClass($, 'CachedApi');
    CachedApiClass = $;
  }
  return CachedApiClass;
}
//region block: exports
export {
  CachedApi as CachedApi1lqobyokeihii,
};
//endregion

//# sourceMappingURL=CachedApi.mjs.map
